// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"64050aa86ef8f207073c","293":"18a6ece21b3b90600571","518":"407933e28d5c491d8ffe","779":"0f6e7ce758ed205a77b2"}[chunkId] + ".js";
};